import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { unitStats } from '../../../stats';

export const congressReducer = (scratch: StatsSnapshot) => {
  const stats = unitStats.congress;
  const generated = stats.buildingsGeneration ?? 0;

  scratch.generators.guild.owned += generated;

  return;
};
